import {ReactNode} from 'react';

import ReactDOM from 'react-dom';

import useWindowSize from '@/hooks/WindowSize/WindowSize';

import './styles';

type ButtonContainerProps = {
  sticky?: boolean;
  children: ReactNode;
  withoutBorder?: boolean;
};

export function ButtonContainer({
  children,
  sticky,
  withoutBorder = true,
}: ButtonContainerProps) {
  const {isMobile} = useWindowSize();

  if (sticky && isMobile) {
    return ReactDOM.createPortal(
      <section
        className={`sticky-buttons-mobile-container${withoutBorder ? ' without-border' : ''}`}>
        <section className="buttons-mobile-container">{children}</section>
      </section>,
      document.body,
    );
  }

  return (
    <section className="sticky-buttons-desktop-container">
      <section className="buttons-desktop-container">{children}</section>
    </section>
  );
}
